import request from "@/utils/request";

export default {
    query: (cron) => {
        return request({
            url: '/cron/query',
            method: 'post',
            data: cron
        })
    },
    save: (cron) => {
        return request({
            url: '/cron/save',
            method: 'post',
            data: cron
        })
    },
    run: (id) => {
        return request({
            url: '/cron/run',
            method: 'post',
            data: id
        })
    },
}
